<div class="sva-increased zoom{{zoom}}" [ngClass]="{'full': full}" (click)="showSVModal()">
  <a class="text-pink" href="tel:{{ svaNumber }}">{{ svaNumber }}</a>
  <a class="text-sva" href="tel:{{ svaNumber }}" [innerHTML]="svaTarif"></a>
</div>
